export enum OrganizationUserRole {
  MEMBER = 'MEMBER',
  ADMIN = 'ADMIN',
  VIEW_ONLY_MEMBER = 'VIEW_ONLY_MEMBER',
  LLM_ONLY = 'LLM_ONLY'
}

export interface OrganizationMember {
  username: string;
  firstName: null;
  lastName: null;
  userId: string;
  joinedAt: number;
  lastActivityAt: null | number;
  avatar: string;
  email: string;
  gitHub: boolean;
  google: boolean;
  role: OrganizationUserRole;
  deleted: boolean;
  pending: boolean;
}

export type OrganizationPaymentPlan =
  | 'Free'
  | 'startup_workspace'
  | 'teams_workspace'
  | 'pro_workspace'
  | 'enterprise_workspace'
  | 'individual_organization'
  | 'starter_organization'
  | 'enterprise_organization'
  | 'platform_pro'
  | 'platform_pro_spans';

export interface APIOrganization {
  academic: boolean;
  active: boolean;
  backgroundLogoColor: string;
  id: string;
  logoUrl: string;
  membersCount: number;
  // this flag is never used on the FE side
  membersPreview: OrganizationMember[] | null;
  name: string;
  onlyAdminsInviteByEmail: boolean;
  payOverride: boolean;
  paymentPlan: OrganizationPaymentPlan;
  role: OrganizationUserRole;
  startup: boolean;
  storageUsage: number;
  suspended: boolean;
  trial: boolean;
  trialEnds: number | null;
  viewOnlyMembersEnabled: boolean;
  withUsageBasedPaymentPlan: boolean;
  workspacesCount: number;
}

export type Organization = APIOrganization & {
  isAdmin: boolean;
  isMember: boolean;
};
